import type { ServiceModalPayload } from '@/services/ModalService/types';
import { RootState } from '@/store/types/RootState';
import { Modals } from '@/features/serviceModal/enums/Modals';
import {
  addModal,
  closeModal,
  replaceModalPayload,
  updateModalPayload,
} from '@/features/serviceModal/store/serviceModalSlice';
import { store } from '@/store/store';

const EMPTY_OBJECT = {};

class ModalService {
  static open(name: Modals, payload: ServiceModalPayload = {}, closeOthers: boolean = false) {
    const modal = store.getState().serviceModal?.[name];
    if (!modal) {
      window.history.pushState({ modalName: name }, '');
      store.dispatch(
        addModal({
          name,
          payload,
          closeOthers,
        }),
      );
    }
  }

  static close(name: Modals) {
    const modal = store.getState().serviceModal?.[name];
    if (modal) {
      store.dispatch(closeModal(name));
    }
  }

  static updatePayload(name: Modals, payload: ServiceModalPayload) {
    const modal = store.getState().serviceModal?.[name];
    if (modal) {
      store.dispatch(updateModalPayload({ name, payload }));
    }
  }

  static replacePayload(name: Modals, payload: ServiceModalPayload) {
    const modal = store.getState().serviceModal?.[name];
    if (modal) {
      store.dispatch(replaceModalPayload({ name, payload }));
    }
  }

  static selector(name: Modals) {
    return (state: RootState) => state.serviceModal?.[name] || EMPTY_OBJECT;
  }
}

export default ModalService;
